import { RESET_SEARCH_QUERY, SET_SEARCH_QUERY } from './searchActions';

const initialState = {
  query: {
    name: '',
    account_search_query: '',
    location: undefined,
    hierarchy_limit: 30,
    hierarchy_offset: 0,
    accounts_limit: 30,
    accounts_offset: 0,
    join_code: '',
  },
};

const webGallerySearchReducer = (state = initialState, action = {}) => {
  switch (action.type) {
    case SET_SEARCH_QUERY: {
      return {
        ...state,
        query: {
          ...initialState.query,
          ...action.query,
        },
      };
    }

    case RESET_SEARCH_QUERY: {
      return {
        ...state,
        query: {
          ...initialState.query,
        },
      };
    }

    default:
      return state;
  }
};

export { initialState };
export default webGallerySearchReducer;
